import { B4RemainingTime } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

/**
 * Retrofit not available content for systems
 */
const RetrofitUnknownWarning: React.FC = () => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <B4RemainingTime sx={{ width: 30, height: 30, mr: 2, color: 'primary.main' }} />
        <Typography variant={downMd ? 'h4' : 'h2'}>{t('retrofit-check.unknown.headline')}</Typography>
      </Box>
      <Typography variant="body2">{t('retrofit-check.unknown.text')}</Typography>
    </>
  )
}

export default RetrofitUnknownWarning
